module.exports = __webpack_public_path__ + "img/transformdata-image1.0bdd6e61.png";